import { useEffect, useRef, useState } from "react";
import { apiFetch } from "./services/apiClient";

function AdminLogin() {
  const [error, setError] = useState("");
  // The key is single-use, so make sure it is only verified once (React StrictMode runs effects twice in dev).
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(window.location.search);
    const type = params.get("t");
    const storeId = params.get("slr");
    const accessKey = params.get("k");

    if (type !== "adm" || !storeId || !accessKey) {
      setError("Invalid or missing login link. Please log in again from the Admin panel.");
      return;
    }

    const verify = async () => {
      try {
        const res = await apiFetch("/seller/verifyOtp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ type: "admin", storeId, accessKey }),
        });
        const data = await res.json();

        if (res.status === 200 && data.token) {
          // Same keys the normal store login (StoreLogin.js) saves
          localStorage.removeItem("token");
          localStorage.setItem("userType", "store");
          localStorage.setItem("storeId", data.sellerId || storeId);
          localStorage.setItem("token", data.token);
          // NEW: marks this session as started by an Admin so Log-Out returns to the Admin app
          localStorage.setItem("loginSource", "admin");
          // replace() so the one-time key is not kept in the browser history
          window.location.replace("/dashboard1");
        } else {
          setError(data.message || "Login failed. The access key may be invalid or already used.");
        }
      } catch (err) {
        console.error("Admin hand-off login error:", err);
        setError("Server error. Please try again from the Admin panel.");
      }
    };

    verify();
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif" }}>
      {error ? (
        <div style={{ textAlign: "center", maxWidth: 420, padding: 24 }}>
          <h3 style={{ color: "#c62828" }}>Unable to log in</h3>
          <p>{error}</p>
          <a href="/storeLogin">Go to store login</a>
        </div>
      ) : (
        <p>Logging you in as store...</p>
      )}
    </div>
  );
}

export default AdminLogin;
